/**
 * <one-tooltip> — generic tooltip custom element.
 * Shows on hover/focus (desktop) and click toggle (touch).
 * Auto-aligns horizontally to stay within viewport.
 */
class OneTooltip extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-trigger]');
    this.bubble = this.querySelector('[data-content]');
    if (!this.trigger || !this.bubble) return;

    this.trigger.addEventListener('pointerenter', (e) => {
      if (e.pointerType === 'mouse') this.open();
    });
    this.trigger.addEventListener('pointerleave', (e) => {
      if (e.pointerType === 'mouse') this.close();
    });
    this.trigger.addEventListener('focus', () => {
      if (this.trigger.matches(':focus-visible')) this.open();
    });
    this.trigger.addEventListener('blur', () => this.close());
    this.trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggle();
    });

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this.close();
    });
  }

  open() {
    this.setAttribute('open', '');
    this.align();
  }

  close() {
    this.removeAttribute('open');
    this.bubble.style.left = '';
    this.bubble.style.right = '';
    this.bubble.style.transform = '';
  }

  toggle() {
    this.hasAttribute('open') ? this.close() : this.open();
  }

  align() {
    // Reset to center first
    this.bubble.style.left = '50%';
    this.bubble.style.right = 'auto';
    this.bubble.style.transform = 'translateX(-50%)';

    const rect = this.bubble.getBoundingClientRect();
    const pad = 8;

    if (rect.left < pad) {
      // Overflows left — pin to left edge
      this.bubble.style.left = '0';
      this.bubble.style.transform = 'none';
    } else if (rect.right > window.innerWidth - pad) {
      // Overflows right — pin to right edge
      this.bubble.style.left = 'auto';
      this.bubble.style.right = '0';
      this.bubble.style.transform = 'none';
    }
  }
}

customElements.define('one-tooltip', OneTooltip);
